import { useQuery } from '@tanstack/react-query';

import { sessionByIdOptions } from '@/entities/session';

import { useSessionId } from '../../../../model/use-session-id';
import { NoteFeedbackButtons } from './session-note-footer-left-toolbar/note-feedback-buttons';
import { Transcript } from './session-note-footer-left-toolbar/transcript';

export function SessionNoteFooterLeftToolbar() {
    const sessionId = useSessionId();
    const { data: session } = useQuery(sessionByIdOptions(sessionId));

    return (
        <div className="flex items-center gap-6">
            <Transcript
                transcriptId={sessionId}
                deletedAt={session?.transcriptDeletedAt}
                isAutoDeleted={session?.isTranscriptAutoDeleted}
            />
            <NoteFeedbackButtons />
        </div>
    );
}
